import * as types from "./types";
import ActionType from "../../Models/ActionType";

export const fetchWorkers: () => ActionType = () => ({
  type: types.FETCH_WORKERS,
});

export const fetchWorkerPositions: () => ActionType = () => ({
  type: types.FETCH_WORKER_POSITIONS,
});
